import * as React from 'react';

const ArticleContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = (
  props
) => (
  <div className="mx-auto px-4 py-6 sm:py-12">
    <div className="prose prose-indigo lg:prose-lg mx-auto">
      {props.children}
    </div>
  </div>
);

export default ArticleContainer;
